/* eslint camelcase: 0 */
import common from './common/ru_RU';
import confirmation from './confirmation/ru_RU';
import dapps from './dapps/ru_RU';
import header from './header/ru_RU';
import home from './home/ru_RU';
import footer from './footer/ru_RU';
import gettingStarted from './getting-started/ru_RU';
import privacyPolicy from './privacy-policy/ru_RU';
import termsAndConditions from './terms-of-conditions/ru_RU';
import createWallet from './create-wallet/ru_RU';
import accessWallet from './access-wallet/ru_RU';
import interfaceTranslations from './interface/ru_RU';
import team from './team/ru_RU';
import popover from './popover/ru_RU';
import withoutWallet from './without-wallet/ru_RU';
import errorsGlobal from './errors-global/ru_RU';
import trezorError from './errors-trezor/ru_RU';
import ledgerError from './errors-ledger/ru_RU';
import secalotError from './errors-secalot/ru_RU';
import keepkeyError from './errors-keepkey/ru_RU';
import bitboxError from './errors-bitbox/ru_RU';

const ru_RU = {
  common: common,
  confirmation: confirmation,
  dapps: dapps,
  header: header,
  home: home,
  footer: footer,
  gettingStarted: gettingStarted,
  privacyPol: privacyPolicy,
  termsOfConditions: termsAndConditions,
  team: team,
  accessWallet: accessWallet,
  createWallet: createWallet,
  interface: interfaceTranslations,
  popover: popover,
  withoutWallet: withoutWallet,
  errorsGlobal: errorsGlobal,
  trezorError: trezorError,
  ledgerError: ledgerError,
  secalotError: secalotError,
  keepkeyError: keepkeyError,
  bitboxError: bitboxError
};
export default ru_RU;
